import update from 'immutability-helper'
import {
  PAYMENT_INFO_SUCCESS,
  SETTINGS_HISTORY_SUCCESS,
  LOADING_SETTINGS_HISTORY,
  SET_STORE_SUCCESS,
  LOGGED_OUT,
  LOADING_CHECKOUT_SETTINGS,
  LOADING_INVOICE_NUMBER,
  LOAD_INVOICE_NUMBER,
  LOAD_CHECKOUT_STYLING_SUCCESS,
  LOAD_TERMS_LINKS_SUCCESS,
  EMPTY_TERMS_LINKS,
} from '../actions/action-types'

const initialState = {
  paymentInfo: {},
  history: {},
  historyLoading: false,
  checkoutSettingsLoading: false,
  checkoutSettings: { checkoutStyling: {}, termsLinks: {} },
  invoiceNumberLoading: false,
  invoiceNumber: 0,
}

// eslint-disable-next-line default-param-last
const settings = (state = initialState, action) => {
  switch (action.type) {
    case PAYMENT_INFO_SUCCESS:
      return update(state, {
        paymentInfo: { $set: action.response },
      })
    case SETTINGS_HISTORY_SUCCESS:
      return update(state, {
        history: { $set: action.response },
      })
    case LOADING_SETTINGS_HISTORY:
      return update(state, {
        historyLoading: { $set: action.loading },
      })
    case LOGGED_OUT:
    case SET_STORE_SUCCESS:
      return initialState
    case LOADING_CHECKOUT_SETTINGS:
      return update(state, {
        checkoutSettingsLoading: { $set: action.loading },
      })
    case LOAD_CHECKOUT_STYLING_SUCCESS:
      return update(state, {
        checkoutSettings: {
          checkoutStyling: {
            $merge: action.response.checkoutStyling || {},
          },
        },
      })
    case LOAD_TERMS_LINKS_SUCCESS:
      return update(state, {
        checkoutSettings: { termsLinks: { $merge: action.response.links } },
      })
    case EMPTY_TERMS_LINKS:
      return update(state, {
        checkoutSettings: { termsLinks: { $set: {} } },
      })
    case LOADING_INVOICE_NUMBER:
      return update(state, {
        invoiceNumberLoading: { $set: action.loading },
      })
    case LOAD_INVOICE_NUMBER:
      return update(state, {
        invoiceNumber: { $set: action.response },
      })
    default:
      return state
  }
}

export default settings
